module.exports = __webpack_public_path__ + "static/media/Varp-L.1176161c.jpg";